module.exports = __webpack_public_path__ + "static/media/logo-vimeo.8f0c9d7b.svg";